import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';
import { STATUSES, TYPES } from '@/constants/booking';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';

const getInitialState = (): BookingState => ({
  booking: {
    business_oid: '',
    risk_profile_oid: '',
    type: TYPES.BUSINESS_PAY,
    status: STATUSES.STATUS_CREATED.key,
    purpose: '',
    candidate_number: 1,
    booking_candidates: [
      {
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
        date_of_birth: '',
        additional_services: [],
        source: '',
        tag: null,
      },
    ],
    payment_method: '',
    is_ghc: false,
    ghc_name: '',
    ghc_description: '',
    ghc_question_groups: [],
  },
  list: [],
});

const state: BookingState = {
  ...getInitialState(),
};

const getters: GetterTree<BookingState, RootState> = {};

const actions: ActionTree<BookingState, RootState> = {
  removeCandidate({ commit }, index) {
    commit('REMOVE_CANDIDATE', index);
  },
  syncCandidateNumber({ commit }) {
    commit('SYNC_CANDIDATE_NUMBER');
  },
  fetchList({ commit }, options) {
    return http.v1.boo.fetchList(options).then(({ data }) => {
      const payload = data;
      const items = payload.data.data;

      commit('SET_STATE', { key: 'list', payload: items });

      return {
        items,
        total: payload.data.total,
      };
    });
  },
  fetch({ commit }, oid) {
    return http.v1.boo
      .fetch(oid, {
        params: {
          expand: ['booking_candidates', 'risk_profile', 'request_business'],
        },
      })
      .then(({ data }) => {
        const payload = data.data;
        commit('SET_STATE', { key: 'booking', payload });
      });
  },
  create({ commit }, payload) {
    return http.v1.boo
      .create({
        ...payload,
      })
      .then((response) => {
        if (response.data?.data?.need_feedback) {
          commit(
            'Feedback/SET_STATE',
            { key: 'popup', payload: true },
            { root: true }
          );
        }

        // clear legacy localStorage data
        localStorage.removeItem('last_feedback_at');

        return response;
      });
  },
  candidatePreFetch(_, payload) {
    return http.v1.boo.candidatePreFetch(payload);
  },
  candidate({ commit }, { bookingOid, bookingCandidateOid = null }) {
    return http.v1.boo
      .candidate(bookingOid, bookingCandidateOid)
      .then(({ data }) => {
        const payload = data.data;
        commit('BookingCandidate/SET_BOOKING_CANDIDATE', payload, {
          root: true,
        });
      });
  },
  // consume({ state }, { paymentOid, bookingOid }) {
  //   return http.v1.boo.consume(paymentOid, bookingOid)
  // },
  consume({ state }) {
    return http.v1.boo.consume(state.booking.object_id);
  },
  checkCreditLimit({ state }) {
    return http.v1.boo.checkCreditLimit(state.booking.object_id);
  },
  cancel({ state }) {
    return http.v1.boo.cancel(state.booking.object_id);
  },
};

const mutations: MutationTree<BookingState> = {
  SET_STATE(state, { key, payload }) {
    state[key] = payload;
  },
  REMOVE_CANDIDATE(state, payload) {
    state.booking.booking_candidates?.splice(payload, 1);
  },
  SYNC_CANDIDATE_NUMBER(state) {
    state.booking.candidate_number =
      state.booking.booking_candidates?.length ?? 1;
  },
  RESET_STATE(state) {
    Object.assign(state, getInitialState());
  },
};

const booking: Module<BookingState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default booking;
